<template>
    <div>
        <MainPage @clickBack="clickBack()" customClass="lg:max-w-xl lg:px-12">
            <div><FormTaxAddress ref="form-tax-address"></FormTaxAddress></div>
            <div class="w-full flex pt-4">
                <RedButton customClass="w-64 py-2.5 m-auto"
                    @click="saveAddress()">{{lbl.tax.save}}</RedButton>
            </div>
        </MainPage>
    </div>
</template>

<script>
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import FormTaxAddress from "../component/FormTaxAddress.vue";
import RedButton from "@/components/Button/RedButton.vue";
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";
export default {
    name: "AddTaxAddress",
    
    mixins: [ModalMixin,LocaleMixin],
    components: {
        MainPage,
        FormTaxAddress,
        RedButton
    },
    created: function() {
        
    },
    methods: {
        clickBack: function() {
            this.$router.back();
        },
        saveAddress: function() {
            let formData = this.$refs['form-tax-address'].submitForm();
            if (formData != null) {
                let params = formData.getParams();
                console.log(params);
                this.saveAddressApi(params);
            }
        },
        saveAddressApi: function(params) {
            return new Promise((resolve) => {
                BzbsAddressList.apiSaveTaxAddress(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.$router.back();
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        }
    }
}
</script>

<style>

</style>